export { ProductVariants } from './productVariants.component';
